import { application } from "./application"

// Registers every *_controller.js under this folder, eagerly bundled by Vite.
// Identifiers follow the Stimulus convention: "episode_video_controller.js"
// becomes "episode-video", "episodes/player_controller.js" "episodes--player".
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })

for (const [path, module] of Object.entries(controllers)) {
  const identifier = path
    .replace(/^\.\//, "")
    .replace(/_controller\.js$/, "")
    .replace(/\//g, "--")
    .replace(/_/g, "-")
  application.register(identifier, module.default)
}
